export default __webpack_public_path__ + "static/media/seeadler.8ef1f50c.jpg";